import { FC, useState } from 'react';

import Button from 'wa-storybook/components/general/button/button';
import styles from './select-interests.module.scss';
import { InterestGroup as InterestGroupT } from 'graphql-types';
import infoIcon from 'assets/images/icons/ic_info_outline.svg';
import FocusGroup from './interest-group/focus-group';

type Props = {
  isLoading?: boolean;
  groups: InterestGroupT[];
  onContinue: (selectedGroup: string) => void;
};

const SelectGroupScreen: FC<Props> = ({
  groups,
  onContinue,
  isLoading,
}: Props) => {
  const [selectedGroup, setSelectedGroup] = useState<string | null>(null);

  const onContinueClick = () => {
    if (selectedGroup) {
      onContinue(selectedGroup);
    }
  };

  return (
    <section>
      <h1 className={styles.title}>
        {polyglot.t('home.interests.focus_screen.title')}
      </h1>

      <p className={styles.subtitle}>
        {polyglot.t('home.interests.focus_screen.description_1')}
      </p>

      <div className={styles['interests-container']}>
        {groups.map(group => {
          return (
            <FocusGroup
              onSelect={() => setSelectedGroup(group.id)}
              isSelected={selectedGroup === group.id}
              key={group.id}
              name={group.name}
              icon={group.icon.url}
            />
          );
        })}
      </div>

      <p className={styles['info-card']}>
        <img src={infoIcon} alt='' />
        {polyglot.t('home.interests.focus_screen.info')}
      </p>

      <div className={styles[`button-container`]}>
        <Button
          isLoading={isLoading}
          text={polyglot.t('home.interests.continue')}
          onClick={onContinueClick}
        />
      </div>
    </section>
  );
};

export default SelectGroupScreen;
